export function blog($, InView) {

  function loadMore(url) {
    let $currentButton = $('.js--loadmoreposts');
    let $currentNavigation = $currentButton.closest('.navigation');
    let $place = $('#ajax-placeholder');

    $currentButton.addClass('ajaxloading');
    $place.addClass('ajaxloadingplace').load(url+' .js--blogpaged', function() {
      $currentNavigation.remove();
      $place.removeClass('ajaxloadingplace').removeAttr('id').after('<div id="ajax-placeholder" class="ajax-placeholder"></div>');

      let $blogcards = document.querySelectorAll('.blogcard');

      $blogcards.forEach(function(el) {
        let inview = InView(el, function(isInView, data) {
          if (isInView) {
            el.classList.add('inview-on');
          }
        });
      });
    });
  }

  $('.cardgrid').after('<div id="ajax-placeholder" class="ajax-placeholder"></div>');

  // AJAX Load
  $('body').on( 'click', '.js--loadmoreposts a', function(e) {
    e.preventDefault();
    let url = $(this).attr('href');
    loadMore(url);
  });

  // Embed container
	$('.blogHtmlcontent iframe, .blogHtmlcontent embed').each(function(i,e) {
    if (!$(e).closest('.embed-container').length) {
      $(e).wrapAll('<div class="embed-container"></div>');
    }
	});


  const $sliderFeatured = $('.featuredblogslider');

  if ($sliderFeatured.length) {
    $sliderFeatured.slick({
      arrows: false,
      dots : true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      infinite : true
    });
  }

  const $sliderRelated = $('.slider--related');

  if ($sliderRelated.length) {
    $sliderRelated.slick({
      arrows: false,
      dots : true,
      slidesToShow: 2,
      slidesToScroll: 2,
      variableWidth: false,
      infinite : true,
      responsive : [
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
    });
  }
  const $sliderPopular = $('.popularslider');

  if ($sliderPopular.length) {
    $sliderPopular.slick({
      arrows: false,
      dots : true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite : true
    });
  }


}
